import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarSecondaryService, CclDrawerService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { SessionWidgetService } from "../../../../modules/shared/services/session-widget.service";

@Component({
    selector: "app-recommendations-page",
    templateUrl: "./recommendations-page.view.html",
    styleUrls: []
})
export class RecommendationsPageView implements AfterViewInit, OnInit {

    sessionWidgets: any = [];

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        private drawerService: CclDrawerService,
        public sharedService: SharedService,
        private sessionWidgetService: SessionWidgetService
    ) {}

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.navSecondaryService.sectionLabel = "Event Advisor";
        this.sharedService.enableSessionWidgets = (!this.isUndefined(this.sharedService.event) && !this.isUndefined(this.sharedService.event?.prodIdList) && this.sharedService.event?.prodIdList?.split(",").includes("111"));
        
        if(this.sharedService.enableSessionWidgets) {
            this.fetchAndLoadWIdgetsData();
        }
    }

    navigateTo(item) {
        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/" + item);
    }

    isUndefined(object) {
        if (object == undefined || object == null) {
            return true;
        } else {
            return false;
        }
    }

    async fetchAndLoadWIdgetsData() {
        await this.sessionWidgetService.getRecommendationWidgetsByUUID(this.sharedService.eventUUID).subscribe({
            next: (response) => {
                this.sessionWidgets = response.body;
                this.sharedService.enableSessionWidgets = (this.sharedService.enableSessionWidgets && this.sessionWidgets.length > 0);
              },
              error: (err) => {
                this.sessionWidgets = [];
                this.sharedService.enableSessionWidgets = false;
              } 
        });
      }
}
